export default function ($translate, $rootScope) {
    const loadEnums = () => {
        return {
            KEYS: {
                ALL_CAN_MANAGE: 'ALL_CAN_MANAGE',
                COMPANY_MANAGER_CAN_MANAGE: 'COMPANY_MANAGER_CAN_MANAGE'
            },
            LABELS: {
                ALL_CAN_MANAGE: $translate.instant('company.All can manage'),
                COMPANY_MANAGER_CAN_MANAGE: $translate.instant('company.Only Company manager can manage')
            }
        };
    };

    const enums = loadEnums();

    $rootScope.$on('$translateChangeSuccess', () => {
        enums.LABELS = loadEnums().LABELS;
    });
    return enums;
}



// WEBPACK FOOTER //
// ./src/app/enums/company/siteAccess/index.js